export default __webpack_public_path__ + "static/media/message-overlay.1d2f7dfc.png";